import React from 'react';
import './Logs.css';
import { Select, Table } from 'antd';
const { Option } = Select;

const SearchIcon = '/assets/SearchIcon.svg';
const columns = [
    {
        title: 'SR',
        dataIndex: 'sr',
        key: 'sr',
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: 'QuickActions',
        dataIndex: 'quickActions',
        key: 'quickActions',
    },
    {
        title: 'Time & Date',
        dataIndex: 'timedate',
        key: 'timedate',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
    },
];

const Logs = () => {
    return (
        <div className='logs-container'>
            <div className='logs-main_1'>
                <div className='relative search-container'>
                    <input
                        type='text'
                        placeholder='Search here...'
                        className='search-from-logs'
                    />
                    <img src={SearchIcon} alt='' className='search-icon' />
                </div>
                <div>
                    <Select
                        defaultValue='select'
                        style={{ width: 120, marginRight: 25, height: '36px' }}>
                        <Option value='jack'>Jack</Option>
                        <Option value='lucy'>Lucy</Option>
                        <Option value='disabled' disabled>
                            Disabled
                        </Option>
                        <Option value='Yiminghe'>yiminghe</Option>
                    </Select>

                    <Select
                        defaultValue='Status'
                        style={{ width: 120, height: '36px' }}>
                        <Option value='jack'>Jack</Option>
                        <Option value='lucy'>Lucy</Option>
                        <Option value='disabled' disabled>
                            Disabled
                        </Option>
                        <Option value='Yiminghe'>yiminghe</Option>
                    </Select>
                </div>
            </div>
            <div className='logs-main_2'>
                <div className='logs-tabel'>
                    <div className='logs-text'>Logs</div>
                    <Table
                        columns={columns}
                        dataSource={''}
                        bordered
                        size='middle'
                        pagination={{
                            pageSize: 4,
                        }}
                        className='mytable'
                    />
                </div>
                <div className='logs-availibility'>
                    <div className='logs-text'>Name of the Api</div>
                    <div className='logs-aval-inner'>
                        <p>No Data Available</p>
                        <div className='separator-logs'></div>

                        <p>Request Body</p>
                        <div className='separator-logs'></div>

                        <p>Response Body</p>
                        <div className='separator-logs'></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Logs;
